"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2139],{

/***/ 78620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _design_system_pc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80571);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



/**
 * 전문가 목록·상세 콘텐츠 폭. 이 컴포넌트는 전문가 목록·상세에서만 쓰인다.
 * RD2026-29 에서 당시 시안(RD 카드 585 × 2열) 기준 1170 으로 줄였으나,
 * QAISSUE-10450 수정 시안(7684:14041 목록 / 7684:10193 상세)에서 본문 폭이 1400 으로 확정됐다.
 * (GNB·Footer 는 1170 유지 — 이 컴포넌트와 무관)
 */ var CONTENT_WIDTH = 1400;
var ResponsiveBox = function(_param) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_design_system_pc__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, _objectSpreadProps(_objectSpread({}, props), {
        width: CONTENT_WIDTH,
        maxWidth: CONTENT_WIDTH,
        mx: "auto",
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveBox);


/***/ }),

/***/ 18296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1861);
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91987);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46757);
/* harmony import */ var _display_component_shared__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6286);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71975);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _remodeling_content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var _di_container_auth_gateway_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2885);
/* harmony import */ var _design_system_pc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80571);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52655);
/* harmony import */ var _services_tracking__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19676);
/* provided dependency */ var process = __webpack_require__(98822);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}











var useDisplayComponent = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var handleOldOpenUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", wiseLogParam = arguments.length > 1 ? arguments[1] : void 0;
        var targetUrl = _services_tracking__WEBPACK_IMPORTED_MODULE_9__/* ["default"].combineWiseLogParam */ .Z.combineWiseLogParam(url.startsWith("http") ? url : "".concat("https://remodeling.hanssem.com").concat(url.startsWith("/") ? "" : "/").concat(url), wiseLogParam);
        if (true) {
            window.location.href = targetUrl;
        } else {}
    }, [
        router
    ]);
    var handleAppLinkGnbRemodeling = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var gnbModule = (appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal) ? _remodeling_content__WEBPACK_IMPORTED_MODULE_5__/* .GNB_REMODELING_MODULE_BY_TEMPLATE_NO */ .Jt[appLink.appLinkVal] : undefined;
        if (gnbModule) {
            switch(gnbModule){
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_10__/* .GNB_REMODELING_SECTION */ .UY:
                    handleOldOpenUrl("/main", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_10__/* .GNB_REMODELING_GOODS */ .gi:
                    handleOldOpenUrl("/goods", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_10__/* .GNB_REMODELING_SHOP */ .P1:
                    handleOldOpenUrl("/shop/search", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_10__/* .GNB_REMODELING_START */ .Sh:
                    handleOldOpenUrl("/remodeling-start", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_10__/* .GNB_REMODELING_EVENT */ ._L:
                    handleOldOpenUrl("/event", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_10__/* .GNB_REMODELING_REHOUSE */ .TH:
                    handleOldOpenUrl("/rehouse", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                default:
                    handleOldOpenUrl("/main?module=".concat(gnbModule), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
            }
        } else {
            handleOldOpenUrl("/", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl
    ]);
    var handleAppLinkCateRemodeling = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var query = query_string__WEBPACK_IMPORTED_MODULE_3__.stringify({
            ctgNo: appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal
        });
        handleOldOpenUrl("/goods?".concat(query), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
    }, [
        handleOldOpenUrl
    ]);
    var handleAppLinkGnbMall = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var gnbModule = (appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal) ? _remodeling_content__WEBPACK_IMPORTED_MODULE_5__/* .GNB_MALL_MODULE_BY_TEMPLATE_NO */ .QS[appLink.appLinkVal] : undefined;
        if (gnbModule) {
            switch(gnbModule){
                default:
                    handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/mall.html?module=").concat(gnbModule), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
            }
        } else {
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/mall.html"), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl
    ]);
    var handleAppLinkCateMall = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        if (appLink && appLink.appLinkOption) {
            var categoryClass = appLink.appLinkOption.ctgDepth === "2" ? "L" : appLink.appLinkOption.ctgDepth === "3" ? "M" : "S";
            var query = query_string__WEBPACK_IMPORTED_MODULE_3__.stringify({
                ctgrNo: appLink.appLinkOption.ctgNo,
                categoryall: "".concat(categoryClass).concat(appLink.appLinkOption.ctgNo)
            });
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/category/goHsm").concat(categoryClass, "ctgy.do?").concat(query), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        } else {
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl
    ]);
    var handleAppLinkGnbHomeIdea = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var gnbModule = (appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal) ? _remodeling_content__WEBPACK_IMPORTED_MODULE_5__/* .GNB_HOMEIDEA_MODULE_BY_TEMPLATE_NO */ .Kt[appLink.appLinkVal] : undefined;
        if (gnbModule) {
            switch(gnbModule){
                default:
                    handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/interior.html?module=").concat(gnbModule), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
            }
        } else {
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/interior.html"), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl
    ]);
    var handleLink = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "LINK") {
            if (appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal) {
                handleOldOpenUrl(appLink.appLinkVal, appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "GNB") {
            switch(appLink === null || appLink === void 0 ? void 0 : appLink.appLinkChannel){
                case "MALL":
                    handleAppLinkGnbMall(appLink);
                    break;
                case "HOMEIDEA":
                    handleAppLinkGnbHomeIdea(appLink);
                    break;
                default:
                    handleAppLinkGnbRemodeling(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "CATE") {
            switch(appLink === null || appLink === void 0 ? void 0 : appLink.appLinkChannel){
                case "MALL":
                    handleAppLinkCateMall(appLink);
                    break;
                default:
                    handleAppLinkCateRemodeling(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "PLAN") {
            if (appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal) {
                handleOldOpenUrl("/event/".concat(appLink.appLinkVal, "?eventStatusType=ING"), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
            }
        }
    }, [
        handleAppLinkCateMall,
        handleAppLinkCateRemodeling,
        handleAppLinkGnbHomeIdea,
        handleAppLinkGnbMall,
        handleAppLinkGnbRemodeling,
        handleOldOpenUrl, 
    ]);
    /**
   * appLink와 defaultUrl을 받아 타겟 url로 랜딩하는 함수
   * @param {NewDisplayHandleLinkArgs} appLink 전시 데이터를 담고 있습니다.
   * @param {string} defaultUrl defaultUrl 을 입력하면 linkUrl 이 비어있을때 지정된 defaultUrl 로 이동합니다. linkUrl 과 defaultUrl 둘다 없다면 '/' 로 이동합니다.
   * @returns void
   */ var handleOpenUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink, defaultUrl) {
        var ref;
        if (false) {}
        var ref1;
        var url = (ref1 = (ref = appLink.applink) === null || ref === void 0 ? void 0 : ref.linkUrl) !== null && ref1 !== void 0 ? ref1 : defaultUrl || "/";
        if (appLink.isNewWindow) {
            window.open(url, "_blank");
        } else {
            window.location.href = url;
        }
    }, []);
    var handleNewLink = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var ref, ref1, ref2, ref3, ref4;
        ;
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.applink) && !appLink.applink.appLinkTarget || (appLink === null || appLink === void 0 ? void 0 : (ref = appLink.applink) === null || ref === void 0 ? void 0 : ref.appLinkTarget) === "URL") {
            handleOpenUrl(appLink);
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref1 = appLink.applink) === null || ref1 === void 0 ? void 0 : ref1.appLinkTarget) === "GNB") {
            var ref5;
            switch(appLink === null || appLink === void 0 ? void 0 : (ref5 = appLink.applink) === null || ref5 === void 0 ? void 0 : ref5.appLinkChannel){
                case "MAIN":
                    handleOpenUrl(appLink);
                    break;
                case "MALL":
                    handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "/furnishing"));
                    break;
                case "HOMEIDEA":
                case "REMODELING":
                    handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "/interior"));
                    break;
                default:
                    handleOpenUrl(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref2 = appLink.applink) === null || ref2 === void 0 ? void 0 : ref2.appLinkTarget) === "CATEGORY") {
            handleOpenUrl(appLink);
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref3 = appLink.applink) === null || ref3 === void 0 ? void 0 : ref3.appLinkTarget) === "BNB") {
            var ref6;
            switch(appLink === null || appLink === void 0 ? void 0 : (ref6 = appLink.applink) === null || ref6 === void 0 ? void 0 : ref6.appLinkChannel){
                case "MAIN":
                    handleOpenUrl(appLink);
                    break;
                case "FURNISHING":
                    handleOpenUrl(appLink, "/furnishing");
                    break;
                case "INTERIOR":
                    handleOpenUrl(appLink, "/interior");
                    break;
                case "SHOPSEARCH":
                    handleOpenUrl(appLink, "/shop/search");
                    break;
                case "MY":
                    handleOpenUrl(appLink, "/my");
                    break;
                default:
                    handleOpenUrl(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref4 = appLink.applink) === null || ref4 === void 0 ? void 0 : ref4.appLinkTarget) === "PLAN") {
            var ref7;
            handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "\n          ").concat(appLink === null || appLink === void 0 ? void 0 : (ref7 = appLink.applink) === null || ref7 === void 0 ? void 0 : ref7.linkUrl).concat(appLink.applink.appLinkAddQuery ? "&" + appLink.applink.appLinkAddQuery : ""));
        }
        if (appLink === null || appLink === void 0 ? void 0 : appLink.goodsInfo) {
            handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "/goods/").concat(appLink.goodsInfo.gdsNo));
        }
    }, [
        handleOpenUrl
    ]);
    var handleLogin = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(_asyncToGenerator(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_di_container_auth_gateway_client__WEBPACK_IMPORTED_MODULE_6__/* .authGateway */ .h)().loginGateway.exec();
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var toast = (0,_design_system_pc__WEBPACK_IMPORTED_MODULE_7__/* .useToast */ .pmc)().toast;
    var ref = (0,_design_system_pc__WEBPACK_IMPORTED_MODULE_7__/* .useAlert */ .VYq)(), handleAlertOpen = ref.handleOpen;
    var ref1 = (0,_design_system_pc__WEBPACK_IMPORTED_MODULE_7__/* .useConfirm */ .N4_)(), handleConfirmOpen = ref1.handleOpen, closeConfirm = ref1.handleClose;
    var handleGoScrap = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        router.push("".concat("https://mall.hanssem.com", "/mypage/wishList.do"));
    }, [
        router
    ]);
    var handleAction = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var message = param.message, action = param.action, type = param.type;
        ;
        if (action === "scrap") {
            toast.success("찜 목록에 추가하였습니다.", {
                placement: "bottom",
                variant: "button",
                actionButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_design_system_pc__WEBPACK_IMPORTED_MODULE_7__/* .NewTextButton */ .rTm, {
                    size: "lg",
                    isUnderline: true,
                    color: "color_chip.white",
                    onClick: handleGoScrap,
                    width: 74,
                    children: "찜 목록가기"
                }),
                offset: 87,
                zIndex: _styles__WEBPACK_IMPORTED_MODULE_8__/* .TOAST_Z_INDEX */ .kb
            });
        } else {
            switch(type){
                case "toast":
                    toast.success(message, {
                        alignment: "center",
                        placement: "bottom",
                        variant: "basic",
                        offset: 87,
                        zIndex: _styles__WEBPACK_IMPORTED_MODULE_8__/* .TOAST_Z_INDEX */ .kb
                    });
                    break;
                case "alert":
                    handleAlertOpen({
                        content: message,
                        zIndex: _styles__WEBPACK_IMPORTED_MODULE_8__/* .ALERT_Z_INDEX */ .iO
                    });
                    break;
                case "confirm":
                    if (action === "login") {
                        ;
                        handleConfirmOpen({
                            cancelText: "취소",
                            confirmText: "로그인",
                            content: message,
                            width: "370px",
                            isShowCloseButton: true,
                            zIndex: _styles__WEBPACK_IMPORTED_MODULE_8__/* .CONFIRM_Z_INDEX */ .CJ,
                            handleConfirm: function() {
                                handleLogin();
                            },
                            handleCloseButton: function() {
                                closeConfirm();
                            }
                        });
                    } else {
                        handleConfirmOpen({
                            cancelText: "취소",
                            confirmText: "로그인",
                            content: message,
                            width: "370px",
                            zIndex: _styles__WEBPACK_IMPORTED_MODULE_8__/* .CONFIRM_Z_INDEX */ .CJ
                        });
                    }
                    break;
                default:
                    break;
            }
        }
    }, [
        closeConfirm,
        handleAlertOpen,
        handleConfirmOpen,
        handleGoScrap,
        handleLogin,
        toast, 
    ]);
    return {
        handleLink: handleLink,
        handleNewLink: handleNewLink,
        handleAction: handleAction
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDisplayComponent);


/***/ }),

/***/ 63744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getBadgeColor; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5445);

var getBadgeColor = function(upperCode) {
    return _constants__WEBPACK_IMPORTED_MODULE_0__/* .BADGE_COLOR_MAP */ .X$G[upperCode] || _constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_BADGE_COLOR */ .HyZ;
};


/***/ })

}]);